import { combineReducers } from "redux";
import cartReducer from "./cartReducer";
import categoriesReducer from "./categoriesReducer";
import divisionsReducer from "./divisionsReducer";
import fcmTokenReducer from "./fcmTokenReducer";
import groupsReducer from "./groupsReducer";
import loaderReducer from "./loaderReducer";
import localDivisionReducer from "./localDivisionReducer";
import mainClientReducer from "./mainClientReducer";
import overviewReducer from "./overviewReducer";
import productsReducer from "./productsReducer";
import selectedCartInfo from "./selectedCartInfo";
import selectedCategory from "./selectedCategory";
import userReducer from "./userReducer";
import wishlistReducer from "./wishlistReducer";

const reducers = combineReducers({
  cartItems: cartReducer,
  categories: categoriesReducer,
  divisions: divisionsReducer,
  fcmToken: fcmTokenReducer,
  groups: groupsReducer,
  loading: loaderReducer,
  localDivision: localDivisionReducer,
  overview: overviewReducer,
  products: productsReducer,
  selectedCartInfo: selectedCartInfo,
  selectedCategory: selectedCategory,
  user: userReducer,
  wishlist: wishlistReducer,
  mainClient: mainClientReducer,
});

export default reducers;
